// @flow

import { hpfetch, hpfetchWithoutContentType } from '../util';

export const deleteSingle = (offeringId: number, id: number) => {
  const endpoint = `offerings/${offeringId}/images/`;
  return hpfetch(`${endpoint}${id}`, {
    method: 'DELETE',
  });
};

export const uploadSingle = (offeringId: number, image: any, order: number) => {
  const endpoint = `offerings/${offeringId}/images/`;
  const form = new FormData();
  form.append('offering', String(offeringId));
  form.append('image', image.blob, image.filename);
  form.append('local_identifier', image.filename);
  form.append('initial_order', order.toString());

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
    body: form,
  });
};

export const top = (offeringId: number, id: number) => {
  const endpoint = `offerings/${offeringId}/images/${id}/top/`;

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
  });
};

export const bottom = (offeringId: number, id: number) => {
  const endpoint = `offerings/${offeringId}/images/${id}/bottom/`;

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
  });
};

export const up = (offeringId: number, id: number) => {
  const endpoint = `offerings/${offeringId}/images/${id}/up/`;

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
  });
};

export const down = (offeringId: number, id: number) => {
  const endpoint = `offerings/${offeringId}/images/${id}/down/`;

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
  });
};

export const orderTo = (offeringId: number, id: number, toLocation: number) => {
  const endpoint = `offerings/${offeringId}/images/${id}/to/${toLocation}/`;

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
  });
};

export const bulkOrder = (offeringId: number, fields: any) => {
  return hpfetch(`offerings/${offeringId}/images/bulk_order/`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });
};
